import { connect } from 'react-redux';
import { getProfile } from 'edrolo/domains/profile';
import StaffRibbon from './StaffRibbon';

const mapStateToProps = (state, { classId }) => {
  const profile = getProfile(state);

  return {
    isStaff: profile.get('is_staff'),
  };
};

export default connect(mapStateToProps)(StaffRibbon);
